import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Pencil = createReactComponent("Pencil", ["svg", defaultAttributes, [["line", {
  x1: "18",
  y1: "2",
  x2: "22",
  y2: "6",
  key: "x6disd"
}], ["path", {
  d: "M7.5 20.5L19 9l-4-4L3.5 16.5 2 22l5.5-1.5z",
  key: "nsyti5"
}]]]);
export default Pencil;